// Global search shared types. Results are grouped by entity type; each hit holds
// ids only — the destination URL is built on the client (see result-href.ts).

export type SearchHitType =
  | "client"
  | "document"
  | "case"
  | "invoice"
  | "notice"
  | "practitioner"
  | "faq"
  | "wiki";

export interface SearchHit {
  type: SearchHitType;
  id: string;
  title: string;
  subtitle: string;
  clientId: string | null;
}

export interface SearchResults {
  clients: SearchHit[];
  documents: SearchHit[];
  cases: SearchHit[];
  invoices: SearchHit[];
  notices: SearchHit[];
  practitioners: SearchHit[];
  kb: SearchHit[];
}

/** The group keys in display order. */
export const SEARCH_GROUPS: (keyof SearchResults)[] = [
  "clients",
  "cases",
  "documents",
  "invoices",
  "notices",
  "practitioners",
  "kb",
];
